/**
 * @property {string} name
 * @property {number} size
 * @property {string} type
 * @property {number} lastModified
 * @property {string} path - Relative path
 * @property {string} url
 * @property {?File} file
 */
export class FileInfo {
  /**
   * @param {File|{
   *  lastModified: number
   *  name: string
   *  size: number
   *  type: string
   * }} fileInfo
   * @param {string=} path
   * @param {string=} url
   */
  constructor (fileInfo, path, url) {
    this.name = fileInfo.name || null
    this.size = fileInfo.size || 0
    this.type = fileInfo.type || ''
    this.lastModified = fileInfo.lastModified || ''
    this.path = path || ''
    this.url = url || ''
    if (fileInfo instanceof File) {
      this.file = fileInfo
    }
  }
}
